import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { CONSTANTS } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  changeEmail(data: { Email: string; UserName: string }) {
    let url = environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.CHANGE_EMAIL;
    return this.http.put<any>(url, data, { ...this.headers });
  }

  changePassword(data: {
    CurrentPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
    UserName: string;
  }) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.CHANGE_PASSWORD_LINK_API;
    return this.http.post<any>(url, data, { ...this.headers });
  }

  forgotPassword(email: string) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.FORGOT_PASSWORD_API;
    return this.http.post<any>(url, { email });
  }

  resetPassword(data: {
    email: string;
    password: string;
    confirmPassword: string;
    code: string;
  }) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.CHANGE_PASSWORD_LINK_API;
    return this.http.post<any>(url, data, { responseType: "text" as "json" });
  }

  getUserInfor() {
    return this.http.get(
      environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.USER_INFOR,
      this.headers
    );
  }

  getPermission() {
    return this.http.get(
      environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.PERMISSION,
      this.headers
    );
  }

  verifyToken(token: string) {
    const url = `${environment.BASE_API_URL}${CONSTANTS.API.ACCOUNT.VERIFYTOKEN}?userToken=${token}`;
    return this.http.post<any>(url, {}, {});
  }

  changePasswordViaLink(data: {
    CurrentPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
    UserName: string;
  }) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.CHANGE_PASSWORD_LINK_API;
    return this.http.post<any>(url, data, {});
  }

  resetPasswordWithToken(data: {
    newPassword: string;
    confirmPassword: string;
    userName: string;
    token: string;
  }) {
    let url =
      environment.BASE_API_URL +
      CONSTANTS.API.ACCOUNT.VALIDATE_FORGOT_PASSWORD_API;
    return this.http.post<any>(url, data, {});
  }
}
